import { Link, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { HiPlus } from 'react-icons/hi'

import { PageContent, PageHeader } from '../../../../layout'
import {
  Breadcrumbs,
  TextField,
  Table,
  TableProvider,
  Button,
  Fab,
  useTableContext,
  IconButton,
  Chip
} from '../../../../components'
import { useDebounce } from '../../../../utils'
import { Box } from '@mui/material'
import Edit from '@mui/icons-material/Edit'
import { useLoadUsers } from 'modules/administrator/hooks'

const UserListPageProvided = () => {
  const navigation = useNavigate()
  const { pagination, setPagination } = useTableContext()
  const [search, setSearch] = useState('')

  const searchDebounced = useDebounce(search, 250)

  const {
    data: users,
    isLoading: usersLoading,
    isFetching: usersFetching
  } = useLoadUsers({
    ...pagination,
    page: (pagination.page || 0) + 1,
    search: searchDebounced
  })

  const handleSearch = (event: any) => {
    setSearch(event.target.value.toUpperCase())
    setPagination({ page: 0 })
  }

  const columns: any[] = [
    {
      field: 'id',
      headerName: 'Código',
      width: 100
    },
    {
      field: 'username',
      headerName: 'Usuário',
      flex: 1,
      minWidth: 200
    },
    {
      field: 'email',
      headerName: 'E-mail',
      width: 200
    },
    {
      field: 'role',
      headerName: 'Função',
      width: 160,
      renderCell: (row: any) => row?.value?.name
    },
    {
      field: 'active',
      headerName: 'Ativo',
      headerAlign: 'center',
      align: 'center',
      renderCell: (row: any) => {
        if (row?.row?.active === 1) {
          return <Chip label="SIM" color="success" />
        } else {
          return <Chip label="NÃO" color="warning" />
        }
      }
    },
    {
      field: 'actions',
      headerName: 'Ação',
      headerAlign: 'center',
      align: 'center',
      renderCell: (row: any) => {
        return (
          <IconButton
            title="Editar"
            onClick={() => navigation(`/users/${row?.row?.id}/edit`)}
            color="primary"
          >
            <Edit />
          </IconButton>
        )
      }
    }
  ]

  return (
    <>
      <PageHeader>
        <div
          style={{
            fontSize: 22,
            fontWeight: 800,
            marginBottom: '.5rem',
            height: 40,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          Usuários
        </div>
        <div>
          <Breadcrumbs aria-label="breadcrumb">
            <Link to="/home" color="#262626" style={{ color: '#595959' }}>
              Início
            </Link>
            <span style={{ color: '#595959' }}>Usuários</span>
          </Breadcrumbs>
        </div>
      </PageHeader>
      <PageContent>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            marginBottom: 20,
            justifyContent: 'space-between'
          }}
        >
          <TextField
            placeholder="Pesquisar ..."
            style={{ width: '100%', maxWidth: 400 }}
            onChange={handleSearch}
            value={search}
            type="search"
          />
          <Button
            sx={{
              display: { md: 'flex', sm: 'none', xs: 'none' },
              fontWeight: 700
            }}
            size="small"
            startIcon={<HiPlus size={18} />}
            onClick={() => navigation('create')}
          >
            Novo Usuário
          </Button>
        </div>
        <div style={{ margin: '1rem 0' }}>
          <Table
            rowCount={users?.meta.query.totalItems}
            getRowId={(row: any) => row.id}
            columns={columns}
            rows={users?.data || []}
            loading={usersLoading || usersFetching}
          />
        </div>
        <Box
          sx={{
            margin: 0,
            top: 'auto',
            right: 20,
            bottom: 20,
            left: 'auto',
            position: 'fixed',
            display: { md: 'none' }
          }}
        >
          <Fab
            style={{ background: '#023770' }}
            onClick={() => navigation('create')}
          >
            <HiPlus size={24} color="white" />
          </Fab>
        </Box>
      </PageContent>
    </>
  )
}

export const UserList = () => (
  <TableProvider>
    <UserListPageProvided />
  </TableProvider>
)

export default UserList
